"use strict";

module.exports = {
  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  UPSERT: 'UPSERT',
  RESTORE: 'RESTORE',
  NOTIFICATION_UPDATE: 'NOTIFICATION_UPDATE'
};